import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { AuthApi, AuthQueryKey, UnauthApi, UnauthQueryKey } from '@/api';
import { InfiniteListWithMoreButton } from '@/app/donation/_components/InfiniteListWithMoreButton';
import { DONATION_ROUTES } from '@/constants';
import { useWebviewTypeEntry } from '@/hooks/useWebviewTypeEntry';
import { useAuthStore } from '@/stores/AuthStore';
import { BenefitCard } from '../BenefitCard';
import { InfiniteListMoreButton } from '../InfiniteListMoreButton';
interface BenefitsContentProps {
  institutionId: number;
}
const PAGE_SIZE = 10;
export const BenefitsContent = t0 => {
  const $ = _c(16);
  const {
    institutionId
  } = t0;
  const isLogin = useAuthStore(_temp);
  const {
    entry
  } = useWebviewTypeEntry();
  let t1;
  if ($[0] !== entry || $[1] !== institutionId) {
    t1 = [institutionId, PAGE_SIZE, entry];
    $[0] = entry;
    $[1] = institutionId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const commonQueryKey = t1;
  let t2;
  if ($[3] !== commonQueryKey || $[4] !== isLogin) {
    t2 = [commonQueryKey, ...(isLogin ? AuthQueryKey["get:/wello/v2/auth/home/institution-event"]() : UnauthQueryKey["get:/wello/v2/allows/home/institution-event"]())];
    $[3] = commonQueryKey;
    $[4] = isLogin;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const queryKey = t2;
  const queryFn = isLogin ? AuthApi["get:/wello/v2/auth/home/institution-event"] : UnauthApi["get:/wello/v2/allows/home/institution-event"];
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <InfiniteListMoreButton />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== entry || $[8] !== institutionId || $[9] !== queryFn) {
    t4 = t5 => {
      const {
        pageParam
      } = t5;
      return queryFn({
        query: {
          institutionId,
          page: pageParam,
          size: PAGE_SIZE,
          entry,
          excludeEndedYN: true
        }
      }).then(_temp2);
    };
    $[7] = entry;
    $[8] = institutionId;
    $[9] = queryFn;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = isLogin !== undefined;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <p className={cn("py-80 text-center font-400 text-Gray-550 typo-body2", "mobile-tablet:typo-body3")}>등록된 혜택이 없어요.</p>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== queryKey || $[13] !== t4 || $[14] !== t5) {
    t7 = <div><div className="flex flex-col gap-12"><InfiniteListWithMoreButton moreButtonComponent={t3} queryKey={queryKey} queryFn={t4} pageSize={PAGE_SIZE} enabled={t5} renderItem={_temp3} getItemKey={_temp4} emptyComponent={t6} /></div></div>;
    $[12] = queryKey;
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
function _temp(state) {
  return state.isLogin;
}
function _temp2(data) {
  return data.data?.context?.contents ?? [];
}
function _temp3(item, index) {
  return <BenefitCard title={item.title} bannerUrl={item.bannerImageUrl} pcBannerUrl={item.pcBannerImageUrl} href={DONATION_ROUTES.MY_ETC_EVENT_DETAIL.pathname({
    eventId: item.eventId
  })} priority={index < 2} />;
}
function _temp4(item_0) {
  return item_0.eventId;
}